import * as React from 'react';
import { Dispatch } from 'redux';
import { useDrop } from 'react-dnd';

import { StoreState } from '../../../reducers';
import { StyledDropTarget, StyledSmallDropTarget } from './styles';
import { DndItemTypes } from '../../../typings/dnd';
import { moveDriveItemInFolder } from '../../../containers/DriveItemList/actions';

interface FolderDropTargetProps {
	folderId: number;
	isSmall?: boolean;
	dispatch: Dispatch<StoreState>;
}

const FolderDropTarget = ({ folderId, isSmall, dispatch }: FolderDropTargetProps) => {
	const [{ isOver, canDrop }, drop] = useDrop({
		accept: DndItemTypes.DRIVE_ITEM,
		canDrop: (item, monitor) => {
			const { driveItem: { id } } = monitor.getItem();
			return folderId !== id;
		},
		drop: (item, monitor) => {
			const { driveItem: { id } } = monitor.getItem();
			dispatch(moveDriveItemInFolder(folderId, id));
		},
		collect: monitor => ({
			isOver: !!monitor.isOver(),
			canDrop: !!monitor.canDrop(),
		}),
	});

	const DropTarget = isSmall ? StyledSmallDropTarget : StyledDropTarget;

	return (
		<DropTarget
			ref={drop}
			canDrop={isOver && canDrop}
		/>
	);
};

export default FolderDropTarget;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/DriveItemList/FolderDropTarget/index.tsx